import { NextPageWithLayout } from '../_app'
import { ReactElement } from 'react'
import Head from "next/head";
import Find from '../../components/_common/FindComponent/Find';
import { Box } from "@mui/material";
import RBhuLayout from '../../design/RBhu/_layouts/RBhuLayout';
import { useRuntimeConfig } from '../../utils/contexts/RuntimeContext/RuntimeConfigContext';

const RBHirdetesListaPage: NextPageWithLayout = () => {
	const runtimeConfig = useRuntimeConfig();

	return (
		<>
			{runtimeConfig.NODE_ENV === 'production' ? (
				<Head>
					<meta http-equiv="refresh" content="0; url=https://racingbazar.hu" />
				</Head>
			) : (
				<Box sx={{ py: 3 }}>
					<Find pageUrl="/" />
				</Box>
			)}
		</>
	)
}

export default RBHirdetesListaPage;

// ----------------------------------------------------------------------

RBHirdetesListaPage.getLayout = function getLayout(page: ReactElement) {
	return <RBhuLayout>{page}</RBhuLayout>
}